/**
 * Glass transparency runner. Watches the user's glass-transparency setting and
 * pushes it live onto the page (a CSS variable the glass surfaces read), so the
 * slider in Settings updates the menu/sheets in real time and the persisted
 * choice is applied on every load. Renders nothing.
 */
import { useEffect } from 'react';
import { useSettingsStore } from '@/store/settings';
import { applyGlass } from '@/ui/glass';

export function GlassRunner() {
  const glassTransparency = useSettingsStore((s) => s.glassTransparency);
  useEffect(() => {
    applyGlass(glassTransparency);
  }, [glassTransparency]);
  return null;
}
